import React, { useCallback, useEffect, useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { Cohort } from 'root-constants'
import {
  selectCurrentVariantCohort,
  selectSubscriptionList,
} from 'root-redux/selects/common'
import { eventLogger } from 'services/eventLogger.service'
import { googleAnalyticsLogger } from 'services/googleAnalytics.service'
import { PURCHASE_PAGES_MAP } from 'page-constants'
import { selectUUID } from 'root-redux/selects/user'
import { useLocation } from 'react-router'
import { PurchasePageType } from 'modules/purchase/constants'
import { Container } from 'components/Container'
import { goTo } from '../../browserHistory'
import { StyledResult as S } from './Result.styles'
import { EnergyLevel, Slider, StressScore, Video } from './components'

export const Result: React.FC = () => {
  const { t } = useTranslation()
  const { search } = useLocation()

  const cohort = useSelector(selectCurrentVariantCohort)
  const subscriptions = useSelector(selectSubscriptionList)
  const uuid = useSelector(selectUUID)

  const isQuizCohort = useMemo(() => cohort === Cohort.VARIANT_TWO, [cohort])

  useEffect(() => {
    eventLogger.logResultPageShown(PurchasePageType.WEB_LANDING)
  }, [])

  const handleClick = useCallback(() => {
    eventLogger.logResultPageCompleted()
    googleAnalyticsLogger.logCheckoutStarted(subscriptions)
    window.fbq('track', 'InitiateCheckout', {}, { eventID: uuid })

    goTo({ pathname: PURCHASE_PAGES_MAP[cohort as Cohort], search })
  }, [subscriptions, uuid, search, cohort])

  return (
    <S.Root>
      {isQuizCohort ? <Video /> : <Slider />}
      <Container>
        <S.Title>{t`result.title`}</S.Title>
        <S.Subtitle>{t`result.subtitle`}</S.Subtitle>
      </Container>

      <S.Separator />
      <Container>
        <S.PersonalSummary>{t`result.personalSummary`}</S.PersonalSummary>
        <StressScore />
      </Container>

      <S.Separator />
      <EnergyLevel />

      <Container>
        <S.Button type="button" onClick={handleClick}>
          {t`result.buttonText`}
        </S.Button>
      </Container>
    </S.Root>
  )
}
